<template>
    <v-footer
            height="auto"
    >
        <v-card flat tile class="flex">
            <v-card-text class="pa-0">
                <v-layout
                        row
                        wrap
                >
                    <v-flex
                            grey
                            darken-4
                            white--text
                            text-md-left
                            text-sm-center
                            text-xs-center
                            md4 sm12 xs12
                    >
                        <span class="copyright btn-height">&copy;2019 — <strong>JitEvent</strong> — {{$t('app.copy_right')}} <span :class="$vuetify.breakpoint.smAndDown ? 'company-name' : '' ">{{$t('app.company_name')}}</span></span>
                    </v-flex>
                    <v-flex
                            grey
                            darken-4
                            text-xs-center
                            white--text
                            md4 sm12 xs12
                    >
                        <a href="https://www.optitable.com/optievent-privacy/" class="btn-height footer-link" target="_blank">{{$t('form.pp')}}</a>
                    </v-flex>

                    <v-flex
                            grey
                            darken-4
                            text-md-right
                            text-sm-center
                            text-xs-center
                            white--text
                            md4 sm12 xs12
                    >
                        <v-menu
                                left
                                offset-y
                                origin="center center"
                                transition="scale-transition"
                        >
                            <v-btn
                                    flat
                                    color="white darken-2"
                                    dark
                                    slot="activator"
                            >
                                {{ $t('languages.' + getCurrentLanguage ) }}
                            </v-btn>
                            <v-list>
                                <v-list-tile
                                        v-for="(language, index) in languages"
                                        :key="index"
                                        @click="changeLanguage(language)"
                                >
                                    <v-list-tile-title>{{ $t('languages.' + language ) }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<script>
    import i18n, {languages} from "~/i18n";
    export default {
        name: "public-footer",
        data() {
            return {
                languages: languages
            }
        },
        computed: {
            getCurrentLanguage() {
                return this.$store.state.lang;
            }
        },
        methods: {
            changeLanguage(language) {
                this.$store.dispatch('setLang', language).then(() => {
                    this.$router.replace({params: {'lang': language}, query: this.$route.query});
                });
            },
        }
    }
</script>

<style scoped>
    .copyright {
        padding: 10px;
    }
    .btn-height {
        line-height: 48px;
    }
    .footer-link {
        color: white;
    }
</style>